<template>
  <div class="returnPage" @click="returnHistory">
    <img src="../../assets/img/registrationLogin/returnPage_icon.png" alt="返回上一页" />
  </div>
</template>

<script>
export default {
  props: ['type'],
  components: {},
  data() {
    return {
      typeWay: this.type,
    };
  },
  computed: {},
  watch: {},
  methods: {
    returnHistory() {
      // this.$router.go(-1);
      switch (this.type) {
        case 'psd':
          this.$emit('psdWorld');
          break;
        case 'retrievePassword':
          this.$emit('retrievePassword');
          break;
        case 'resetPsdPush':
          this.$emit('resetPsdPush');
          break;
        case 'getCode':
          this.$emit('getCodeReturn');
          break;

        default: {
          this.$router.go(-1);
          break;
        }
      }
    },
  },
  created() {},
  mounted() {},
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {},
};
</script>
<style lang="scss" scoped>
.returnPage {
  padding: 0.22rem 0 0 0.62rem;
}

img {
  width: 43px;
  height: 43px;
}
</style>
